'use client'

import React from 'react'

import type { Header } from '@/payload-types'

import { Header1 } from './layouts/Header1/header'
import { Header2 } from './layouts/Header2/header'
import { Header3 } from './layouts/Header3/header'
import { Header4 } from './layouts/Header4/header'
import { Header5 } from './layouts/Header5/Header'
import { cn } from '@/utilities/ui'
import MobileHeader from './MobileNav/mobileHeader'

const hedearMap = {
  'header-1': Header1,
  'header-2': Header2,
  'header-3': Header3,
  'header-4': Header4,
  'header-5': Header5,
}
const HeaderClient = ({
  data: headerData,
  hideTopBar = false,
}: {
  data?: any
  hideTopBar?: boolean
}) => {
  const HeaderComponent = headerData?.type
    ? hedearMap[headerData?.type as keyof typeof hedearMap]
    : Header2

  // Header3 is self-contained with floating design, no need for dual rendering
  if (headerData?.type === 'header-3') {
    return (
      <HeaderComponent
        navItems={headerData?.navItems as any}
        logo={headerData?.logo}
        rightCta={headerData?.rightCta}
      />
    )
  }

  // Other headers use the dual rendering system
  return (
    <header className="w-full font-sans">
      <nav className="hidden lg:block">
        <div
          className={cn(
            'fixed top-0 left-0 w-full bg-background z-[991] shadow-lg transition-transform duration-1000',
            hideTopBar ? 'visible translate-y-0' : '-translate-y-[120%]',
          )}
        >
          <HeaderComponent
            navItems={headerData?.navItems as any}
            logo={headerData?.logo}
            rightCta={headerData?.rightCta}
          />
        </div>
        <div className="sticky top-0 z-50 mx-2 sm:mx-4 lg:mx-6 xl:mx-8 mt-2">
          <div className="bg-background/95 backdrop-blur-sm rounded-lg shadow-lg border border-border/50 overflow-hidden">
            <HeaderComponent
              navItems={headerData?.navItems as any}
              logo={headerData?.logo}
              rightCta={headerData?.rightCta}
            />
          </div>
        </div>
      </nav>
      {/* Mobile Header */}
      <nav className="sticky top-0 lg:hidden z-50 mx-2 sm:mx-4 mt-2">
        <div className="bg-background/95 backdrop-blur-sm rounded-lg shadow-lg border border-border/50 overflow-hidden">
          <MobileHeader
            logo={headerData?.logo}
            navItems={headerData?.navItems}
            rightCta={headerData?.rightCta}
          />
        </div>
      </nav>
    </header>
  )
}

export default HeaderClient
